import React from "react"
import DropdownOrder from "./DropdownOrder"

class SearchSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...props
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }

  render() {
    const { order, showActivity } = this.state
    const buttonText = showActivity ? 'Hide Notifications' : 'Show Notifications'

    return(
      <div className='row-fluid'>
        <div className='span6'>
          <DropdownOrder
            sortLoans={this.props.sortLoans}
            order={order}/>
        </div>
        <div className='span6 push-text-right'>
          <button type="button" id='show-updates' className='btn-default text-color-white button-as-link' onClick={this.props.toggleActivity}>
             {buttonText}
          </button>
        </div>
      </div>
    )
  }
}

export default SearchSelect;
